import { Link } from "react-router-dom";
import { Lock, Zap } from "lucide-react";
import { getEngine } from "../config/engines";

export default function EnginePlaceholder({ engineId }) {
  const cfg = getEngine(engineId);
  return (
    <div className="ambient-bg min-h-full px-8 py-12">
      <div className="max-w-3xl">
        <div className="flex items-center gap-2 text-[10px] text-amber-500 font-mono uppercase tracking-[0.3em] mb-4">
          <Lock size={12} /> Próximamente
        </div>
        <h1 className="font-display font-black text-4xl lg:text-5xl tracking-tight text-zinc-50">
          {cfg.humanLabel}
        </h1>
        <p className="text-lg text-zinc-400 mt-4 leading-relaxed">
          {cfg.question}
        </p>
        <p className="text-sm text-zinc-500 mt-3 max-w-2xl leading-relaxed">
          {cfg.anticipationText || "Estamos preparando esto con tu cartera — pronto lo vas a ver aquí."}
        </p>

        <div className="mt-6 flex items-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.2em] px-5 py-2.5 bg-amber-500 text-black hover:bg-amber-400 btn-glow-amber"
          >
            <Zap size={13} /> Ir a Hoy
          </Link>
        </div>
      </div>
    </div>
  );
}
